import React, { useEffect } from 'react'
import { checkUserSubscription } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { removeUserDetails } from '../../store/slices/userSlice';

const Auth2 = ({ children }) => {
    const { userDetails } = useSelector((state) => state.persisted.userSlice);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const checkSubscription = async () => {
        try {
            const response = await checkUserSubscription(userDetails?.token);

        } catch (error) {
            if (error?.response?.data?.error?.status == 0) {
                // subscription has expired now...
             dispatch(removeUserDetails());
                toast.error(t("248"));
                navigate("/");

            }
            else if (error?.response?.data?.error?.status == 1) {
                //  subscription has expired now..
               dispatch(removeUserDetails());
                // toast.error(t("111"));
                navigate("/low-balance");

            }
            else if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("249"));
                navigate('/');
            }
            else {
                console.log("Don't do anything///");
            }
        }
    }

    useEffect(() => {
        if (userDetails?.token) {
            checkSubscription();
        }
        else {
            navigate("/");
        }
    }, [userDetails, location]);
    return (
        <>{children}</>
    )
}

export default Auth2